import { useLayoutStore } from '@/stores/layoutStore';

function getChildTabPrintMarkup(source: string) {
  const imageMarkup = `
    <html>
      <head>
        <script>
          function printWindow() {
            window.setTimeout(() => {
              window.print();
              window.close();
            }, 10);
          }
        </script>
      </head>
      <body onload="printWindow()">
        <img src="${source}" />
      </body>
    </html>
  `;

  return imageMarkup;
}

function printChart() {
  const layoutStore = useLayoutStore();

  const childTab = window.open('about:blank', '_new');

  if (!childTab)
    return;

  const markupInjection = getChildTabPrintMarkup(layoutStore.chartImageUrlString);

  childTab.document.open();
  childTab.document.write(markupInjection);
  childTab.document.close();
}

export function usePrintChart() {
  return {
    printChart
  };
}
